import _ from 'lodash';
import moment from 'moment';

export { default as Table } from './Table';

export const textSort =
  (field, parser = x => x) =>
  (a, b) =>
    textSortValue(a, field, parser).localeCompare(textSortValue(b, field, parser));

export const colorSort = index => (a, b) =>
  colorSortValue(a, index).localeCompare(textSortValue(b, index));

export const dateSort = field => (a, b) =>
  dateSortValue(a, field).diff(dateSortValue(b, field));

export const boolSort =
  (field, parser = x => x) =>
  (a, b) =>
    boolSortValue(a, field, parser) - boolSortValue(b, field, parser);

const textSortValue = (object, field, parser) =>
  parser(_.get(object, field) || '').toLowerCase();

const colorSortValue = (object, index) =>
  (_.get(object, `colors[${index}]`) || '').toLowerCase();

const dateSortValue = (object, field) => moment(_.get(object, field));

const boolSortValue = (object, field, parser) =>
  object && parser(object[field]) ? 1 : 0;

////// DEP
export { default as TableSortLabel } from './TableSortLabel';
